export var Personas;
(function (Personas) {
    Personas["CUSTOMER"] = "Customer";
    Personas["DEALER"] = "Dealer";
    Personas["FEED_ADVISOR_DISTRIBUTOR"] = "FeedAdvisorDistributor";
    Personas["SUBDEALER"] = "SubDealer";
    Personas["FEED_ADVISOR_DEALER"] = "FeedAdvisorDealer";
    Personas["ROOT"] = "Root";
    Personas["SUPPORT"] = "Support";
    Personas["SUPPORT_MANAGER"] = "SupportManager";
})(Personas || (Personas = {}));
export var PersonaBusinessScopes;
(function (PersonaBusinessScopes) {
    PersonaBusinessScopes["DISTRIBUTOR"] = "distributor";
    PersonaBusinessScopes["DEALER"] = "dealer";
})(PersonaBusinessScopes || (PersonaBusinessScopes = {}));
export var REGISTER_FIELDS;
(function (REGISTER_FIELDS) {
    REGISTER_FIELDS["personas"] = "personas";
    REGISTER_FIELDS["firstName"] = "firstName";
    REGISTER_FIELDS["lastName"] = "lastName";
    REGISTER_FIELDS["email"] = "email";
    REGISTER_FIELDS["companyName"] = "companyName";
    REGISTER_FIELDS["language"] = "language";
    REGISTER_FIELDS["address"] = "address";
    REGISTER_FIELDS["city"] = "city";
    REGISTER_FIELDS["phone"] = "phone";
    REGISTER_FIELDS["zipCode"] = "zipCode";
    REGISTER_FIELDS["country"] = "country";
    REGISTER_FIELDS["state"] = "state";
    REGISTER_FIELDS["companyIdentifier"] = "companyIdentifier";
    REGISTER_FIELDS["billingPeriod"] = "billingPeriod";
})(REGISTER_FIELDS || (REGISTER_FIELDS = {}));
//# sourceMappingURL=tenant.type.js.map